// Languages.js
'use strict';
'use client';
import { connect } from 'react-redux';

import Languages from '../component/Languages.jsx';
import { getSupportedLanguages } from '../selector/getRemoteConfigComputedData.js';

const mapStateToProps = state => {
  return {
    supportedLanguages: getSupportedLanguages(state),
  };
};

export default connect(mapStateToProps, null)(Languages);
